import { Button } from '@/components/Elements/Button';
import {
  createUrlWithRedirectQuery,
  getSafeRedirectPath,
  isSafeInternalRedirectPath,
} from '@/utils/url';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import {
  createAuthJourneyState,
  isAuthJourneyEntry,
  readAuthJourneyState,
} from '../lib/authJourneyNavigation';

export const AuthBackButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const journeyState = readAuthJourneyState(location.state);

  if (location.pathname === '/auth/login') return null;

  return (
    <Button
      variant="ghost"
      size="md"
      startIcon={<IconArrowLeft aria-hidden="true" className="size-5" />}
      onClick={() => {
        if (journeyState && isAuthJourneyEntry(location.state)) {
          navigate(-1);
          return;
        }

        const redirectPath = new URLSearchParams(location.search).get('to');
        const safeRedirectPath = getSafeRedirectPath(redirectPath);
        const safeRelativeRedirectPath =
          safeRedirectPath && isSafeInternalRedirectPath(safeRedirectPath)
            ? safeRedirectPath
            : null;
        const loginUrl = new URL(
          createUrlWithRedirectQuery('/auth/login', safeRelativeRedirectPath)
        );

        navigate(`${loginUrl.pathname}${loginUrl.search}`, {
          replace: true,
          state: createAuthJourneyState('backward'),
        });
      }}
    >
      {t('戻る')}
    </Button>
  );
};
